import { Auth, API } from 'aws-amplify'
import React, { useEffect, useState } from 'react'
import { Table, TableCell, TableHead, TableRow } from '@aws-amplify/ui-react';
import CaseLawSearchRow from './CaseLawSearchRow';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { Link } from 'react-router-dom';
import {
  PlusLg,
  SortUp,
  SortDown
} from 'react-bootstrap-icons';
import Alert from 'react-bootstrap/Alert';
import Spinner from 'react-bootstrap/Spinner';
import Dropdown from 'react-bootstrap/Dropdown';
import Nav from 'react-bootstrap/Nav';

const CaseLawSearchTable = (props) => {
  const [entities, setEntities] = useState([]);
  const [input, setInput] = useState("");
  const [errorMessage, setErrorMessage] = useState('');
  const [isBusy, setIsBusy] = useState(false);
  const projecttype = 'caselawsearch';
  const navLink = '/filescaselawsearch?projectid=Sample%20Case%20Law%20Review%20Project';

  //Function to fetch from our backend and update customers array
  const getProjects = async () => {
    setIsBusy(true);
    const user = await Auth.currentAuthenticatedUser()
    const token = user.signInUserSession.idToken.jwtToken
    const requestInfo = { headers: { Authorization: token } }
    API.get("DocumentSearchUser", '/userprojects' + `?projecttype=${projecttype}`, requestInfo)
      .then(response => {
        setIsBusy(false);
        setEntities(response);
        console.log(response)
      })
      .catch(error => {
        setIsBusy(false);
        console.log(error);
      })
  };
  useEffect(() => { getProjects() }, [])

  const newProject = async (name) => {
    setIsBusy(true);
    const user = await Auth.currentAuthenticatedUser()
    const token = user.signInUserSession.idToken.jwtToken

    const requestInfo = { headers: { Authorization: token } }
    API.get('DocumentSearchUser', '/addproject' + `?projectid=${name.input}&projecttype=${projecttype}`, requestInfo)
      .then(response => {
        setIsBusy(false);
        setErrorMessage('');
        getProjects();
      })
      .catch(error => {
        setIsBusy(false);
        console.log(token);
        console.log(error)
        if (error.response.status == 406) {
          setErrorMessage('Project already exists!');
        }
      })
  };

  const handleDelete = async (entity) => {
    setIsBusy(true);
    console.log('delete' + entity.id + ' ' + entity.user_id + ' ' + entity.project_id)
    const user = await Auth.currentAuthenticatedUser()
    const token = user.signInUserSession.idToken.jwtToken
    const requestInfo = { headers: { Authorization: token } }

    API.get('DocumentSearchUser', '/deleteproject' + `?projectid=${entity.project_id}&projecttype=${projecttype}`, requestInfo)
      .then(response => {
        getProjects();
        setIsBusy(false);
      })
      .catch(error => {
        setIsBusy(false);
        console.log(error);
      })
  };

  const handleSelectChange = (entity) => {
    console.log('selected ' + entity.project_id)
    props.OnProjectChange(entity)
  };

  const sortColumn = (column, direction) => {
    if (column === 'project_id') {
      if (direction === 'up') {
        const sorted = [...entities].sort((a, b) => { return a.project_id.localeCompare(b.project_id) })
        setEntities(sorted)
      }
      else {
        const sorted = [...entities].sort((a, b) => { return b.project_id.localeCompare(a.project_id) })
        setEntities(sorted)
      }
    }
    else if (column === 'file_count') {
      if (direction === 'up') {
        const sorted = [...entities].sort((a, b) => { return a.file_count - b.file_count })
        setEntities(sorted)
      }
      else {
        const sorted = [...entities].sort((a, b) => { return b.file_count - a.file_count })
        setEntities(sorted)
      }
    }
    else {
      if (direction === 'up') {
        const sorted = [...entities].sort((a, b) => { return a.size - b.size })
        setEntities(sorted)
      }
      else {
        const sorted = [...entities].sort((a, b) => { return b.size - a.size })
        setEntities(sorted)
      }
    }
  }

  return (
    <>
      <Row>
        <Col>
          <br />
          <Breadcrumb>
            <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>Home</Breadcrumb.Item>
            <Breadcrumb.Item active>Case Law Search</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
      </Row>
      <Row>
        <Col>
          <h1 style={{ textAlign: 'center' }}>Select Project Folder</h1>
          <h3 style={{ textAlign: 'center' }}>Create new project or use existing project</h3>
        </Col>
      </Row>
      <Row>
        <Col>
          <h3>Create New Project Folder</h3>
        </Col>
      </Row>
      <Row className='my-4'>
        <Col>
          <div className='text-center'>
            <Dropdown>
              <Dropdown.Toggle variant="secondary">
                Example Project
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item><Nav.Link as={Link} to={navLink}>Sample Case Law Review Project</Nav.Link></Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <Form.Group as={Row} className="mb-3" controlId="formPlaintextPassword">
            <Col sm="5">
              <InputGroup className="mb-3">
                <InputGroup.Text>Project Name:</InputGroup.Text>
                <FormControl
                  placeholder="enter new project name"
                  aria-label="Recipient's username"
                  aria-describedby="basic-addon2"
                  value={input} onChange={(e) => setInput(e.target.value)}
                />
                <Button variant="outline-secondary" id="button-addon2" onClick={() => newProject({ input })}>
                  <PlusLg />
                </Button>
              </InputGroup>
            </Col>
          </Form.Group>
          {/* <b>Create New Project Folder</b><br />
          Project Name: <input placeholder="enter new project name" type="text" value={input} onChange={(e) => setInput(e.target.value)} />
          <button onClick={() => newProject({ input })}>Create</button> */}
        </Col>
      </Row>
      <Row>
        <Col>

          {errorMessage && (
            <Alert key="danger" variant="danger">
              {errorMessage}
            </Alert>
          )}</Col>
      </Row>
      <Row>
        <Col>
          {isBusy &&
            <Spinner animation="border" role="status" variant="primary">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          }
        </Col>
      </Row>
      <Row>
        <Col>
          <Table className='table table-striped'>
            <TableHead className='thead-dark'>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>
                  <strong>Project Name </strong>
                  <Button variant="outline-secondary" id="button-addon2" onClick={() => sortColumn('project_id', 'up')}>
                    <SortUp />
                  </Button>
                  <Button variant="outline-secondary" id="button-addon2" onClick={() => sortColumn('project_id', 'down')}>
                    <SortDown />
                  </Button>
                </TableCell>
                <TableCell>
                  <strong>Documents </strong>
                  <Button variant="outline-secondary" id="button-addon2" onClick={() => sortColumn('file_count', 'up')}>
                    <SortUp />
                  </Button>
                  <Button variant="outline-secondary" id="button-addon2" onClick={() => sortColumn('file_count', 'down')}>
                    <SortDown />
                  </Button>
                </TableCell>
                <TableCell>
                  <strong>File Size </strong>
                  <Button variant="outline-secondary" id="button-addon2" onClick={() => sortColumn('size', 'up')}>
                    <SortUp />
                  </Button>
                  <Button variant="outline-secondary" id="button-addon2" onClick={() => sortColumn('size', 'down')}>
                    <SortDown />
                  </Button>
                </TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <tbody>
              {
                entities.map((thisEntity, index) => {
                  return (
                    <CaseLawSearchRow key={thisEntity.project_id} entity={thisEntity} onDelete={handleDelete} onSelectChange={handleSelectChange} />
                  )
                })
              }
            </tbody>
          </Table>
        </Col>
      </Row>
    </>
  )
}
export default CaseLawSearchTable;